/**
 * Urgency-regel — Bouwbrief Z-09 §2. Hoort bij blocks/zorenza-urgency.liquid.
 *
 * De regel zelf is Liquid en CSS; het bolletje pulseert met een keyframe.
 * Dit bestand doet één ding: §8 melden dat de regel in beeld is geweest.
 *
 * Niet bij het laden van de pagina maar bij het eerst in beeld komen, en
 * hoogstens één keer per paginaweergave. Horizon vervangt bij een
 * variantwissel delen van het koopblok; zou dit op connectedCallback melden,
 * dan telde één bezoeker met drie kleurwissels als vier vertoningen.
 */

import { meld } from '@zorenza/q4-events';

const TAG = 'zorenza-urgency';

/** Eén melding per handle per paginaweergave. */
const gemeld = new Set();

class ZorenzaUrgency extends HTMLElement {
  #kijker = null;

  connectedCallback() {
    const handle = this.dataset.handle || '';
    if (gemeld.has(handle)) return;

    if (!('IntersectionObserver' in window)) {
      this.#meld();
      return;
    }

    this.#kijker = new IntersectionObserver(
      (rijen) => {
        for (const rij of rijen) {
          if (rij.isIntersecting) {
            this.#meld();
            return;
          }
        }
      },
      { threshold: 0.5 }
    );
    this.#kijker.observe(this);
  }

  disconnectedCallback() {
    this.#kijker?.disconnect();
    this.#kijker = null;
  }

  #meld() {
    const handle = this.dataset.handle || '';
    if (gemeld.has(handle)) return;
    gemeld.add(handle);

    this.#kijker?.disconnect();
    this.#kijker = null;

    meld('urgency_bar_shown', { handle, markt: this.dataset.markt || '' });
  }
}

if (!customElements.get(TAG)) customElements.define(TAG, ZorenzaUrgency);
